import { Bath, Boxes, Refrigerator, Sofa, Trees } from "lucide-react";

export const PHONE = "(864) 518-1871";
export const TEL = "tel:+18645181871";

export const SERVICES = [
  { key: "furniture", to: "furniture-removal", n: "01", title: "Furniture", icon: Sofa, items: ["Sofas", "Mattresses", "Recliners", "Dressers"], span: "lg:col-span-7 lg:row-span-2" },
  { key: "appliances", to: "appliance-removal", n: "02", title: "Appliances", icon: Refrigerator, items: ["Fridges", "Washers", "Dryers", "Stoves"], span: "lg:col-span-5" },
  { key: "hottubs", to: "hot-tub-removal", n: "03", title: "Hot Tubs", icon: Bath, items: ["Hot tubs", "Spas", "Decks"], span: "lg:col-span-5" },
  { key: "yardwaste", to: "yard-waste-removal", n: "04", title: "Yard Waste", icon: Trees, items: ["Branches", "Brush", "Leaf bags", "Debris"], span: "lg:col-span-6" },
  { key: "cleanouts", to: "house-cleanout", n: "05", title: "Cleanouts", icon: Boxes, items: ["Garages", "Attics", "Estates", "Rentals"], span: "lg:col-span-6" },
];

export const FAQS = [
  { q: "How does your pricing work?", a: "Upfront and simple. We come out, look at what needs to go, and give you a free price on the spot before we lift anything. No surprises on the bill." },
  { q: "Is the onsite quote really free?", a: "Yes. The quote is 100% free and there's no obligation. If the price works for you, we can usually haul it away right then." },
  { q: "Do you offer same-day pickup?", a: "Yes, we offer same-day pickup across Greenville and nearby. Call early in the day for the best chance at a same-day slot." },
  { q: "What items do you take?", a: "Furniture, appliances, hot tubs, yard waste, and full garage, attic, estate or rental cleanouts. Not sure about an item? Just call and ask." },
  { q: "Do I need to bring things to the curb?", a: "No. Point to what needs to go and our crew does the lifting and loading for you." },
  { q: "What areas do you serve?", a: "Greenville, South Carolina and nearby communities including Taylors, Greer, Simpsonville, Mauldin, Travelers Rest, Five Forks, Easley and Fountain Inn. If you're close by and don't see your town, give us a call." },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
